"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobOfferListQuerySchema = exports.JobOfferUpdateStatusRequestSchema = exports.JobOfferIdPathParamsSchema = void 0;
const zod_1 = require("zod");
exports.JobOfferIdPathParamsSchema = zod_1.z.object({ offerId: zod_1.z.string().uuid() });
exports.JobOfferUpdateStatusRequestSchema = zod_1.z.object({
    status: zod_1.z.enum([
        'ACCEPTED',
        'REJECTED',
    ]),
});
exports.JobOfferListQuerySchema = zod_1.z.object({ industryId: zod_1.z.string().optional() });
